/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as a from "react";
import r from "prop-types";
import { classNames as t } from "@progress/kendo-react-common";
const m = (e) => {
  const s = {
    src: "",
    ...e
  };
  return /* @__PURE__ */ a.createElement(
    "img",
    {
      style: s.style,
      className: t("k-card-media", s.className),
      src: s.src,
      alt: s.alt
    }
  );
};
m.propTypes = {
  className: r.string,
  src: r.string
};
export {
  m as CardImage
};
